const PageTitles = {
    LOGIN: "Login",
    FORGET_PASSWORD: "Forget Password",
    OTP_VERIFICATION: "OTP Verification",
    LOGOUT: "Logout",
    RESET_PASSWORD: "Reset Password",
    DASHBOARD: "Dashboard",
    USER_MANAGEMENT: "User Management",
    USER_MANAGEMENT_DETAILS: "Details",
    AUDIO_MANAGEMENT: "Audio Management",
    GOAL_MANAGEMENT: "Goal Management",
    PROVIDER_MANAGEMENT: "Provider Management",
    SEEKER_MANAGEMENT: "Seeker Management",
    CATEGORY_MANAGEMENT: "Category Management",
    JOB_LISTING: "Job Listing",
    ACCOUNT: "Account",
    AUTHOR_AND_NARRATOR_MANAGEMENT: "Narrator & Author Management"
};

export default PageTitles;
